import script from "./saleContract.vue?vue&type=script&setup=true&lang=js"
export * from "./saleContract.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__